import React, { FunctionComponent, memo } from 'react'
import styles from './Left.module.sass'
import ProjectIcon from 'files/folder.svg'
import TaskIcon from 'files/task-open.svg'
import SettingsIcon from 'files/settings.svg'
import ArchiveIcon from 'files/archive/archive.svg'
import SearchIcon from 'files/search.svg'
import PriceIcon from 'files/price.svg'
import ContactsIcon from 'files/contacts.svg'
import StatisticsIcon from 'files/statistics.svg'
import NavItem from '../NavItem/NavItem'
import clsx from 'clsx'
import { ROUTES } from '../../../http/routes'
import Spacer from '../../etc/Spacer'
import { useRootSelector } from '../../../utils/hooks'
import { HasAllPermissions } from '../../etc/HasPermission'
import { PERMISSIONS } from '../../../constants/permissions'

interface Props {
    className?: string,
}

const Left: FunctionComponent<Props> = props => {
    const user = useRootSelector(state => state.global.user.data)
    return (
        <nav className={clsx(props.className, styles.left)}>
            <NavItem
                text={'Проекты'}
                route={ROUTES.PROJECTS}
                icon={ProjectIcon}
                badge={{
                    text: user?.new_projects || user?.paused_projects,
                    title: user?.new_projects ? 'Новые проекты' : 'Проекты на паузе',
                }}
            />
            <NavItem
                text={'Задачи'}
                route={ROUTES.TASKS}
                icon={TaskIcon}
                badge={{
                    text: user?.requested_tasks,
                    title: 'Запросы на открытие задач'
                }}
            />
            <HasAllPermissions permissions={[PERMISSIONS.PROJECT.ARCHIVE]}>
                <NavItem
                    text={'Архив'}
                    route={ROUTES.ARCHIVE}
                    icon={ArchiveIcon}
                />
            </HasAllPermissions>

           { <NavItem
                text={'Статистика'}
                route={ROUTES.STATISTICS}
                icon={StatisticsIcon}
            />}
            <NavItem
                text={'Поиск'}
                route={ROUTES.SEARCH}
                icon={SearchIcon}
            />
            <NavItem
                text={'Прайс'}
                route={ROUTES.PRICE}
                icon={PriceIcon}
            />
            <NavItem
                text={'Контакты'}
                route={ROUTES.CONTACTS}
                icon={ContactsIcon}
            />
            <Spacer/>
            <HasAllPermissions permissions={[PERMISSIONS.SETTINGS.ACCESS]}>
                <NavItem
                    text={'Настройки'}
                    route={ROUTES.SETTINGS}
                    icon={SettingsIcon}
                    className={styles.settings}
                />
            </HasAllPermissions>
        </nav>
    )
}

export default memo(Left)


